/*
 * Usedguns search v2.
 *
 * Replaces the results Shopify renders on /search with results from the search
 * index, which can actually see the whole catalogue. This theme’s search page is
 * driven entirely by the index; ?searchv2=0 turns it off for comparison.
 *
 * Filtering happens in place: the URL is kept in sync via pushState so links,
 * sharing and the back button all behave, but no page reload occurs. The
 * options themselves come from live facet counts, ordered by the metaobject
 * list the theme still supplies.
 */
(function () {
  'use strict';

  var CFG = window.UG_SEARCH_V2;
  if (!CFG || !CFG.apiBase) return;
  // ?searchv2=0 disables this and leaves Shopify's own rendering in place —
  // useful for comparing against the live theme when something looks wrong.
  if (new URLSearchParams(window.location.search).get('searchv2') === '0') return;

  /* ---------------------------------------------------------------- params */

  // The storefront's filter names are Shopify's; the API's are its own.
  var FACET_PARAMS = {
    'filter.p.m.wk_custom_field.cus_category': 'category',
    'filter.p.m.wk_custom_field.cus_subcategory': 'subcategory',
    'filter.p.m.wk_custom_field.cus_condition': 'condition',
    'filter.p.m.wk_custom_field.cus_calibre': 'calibre',
    'filter.p.m.wk_custom_field.cus_action': 'action',
    'filter.p.m.wk_custom_field.cus_state': 'state'
  };

  var TEXT_PARAMS = {
    'filter.p.m.wk_custom_field.cus_make': 'make',
    'filter.p.m.wk_custom_field.cus_model': 'model',
    'filter.p.m.wk_custom_field.cus_item': 'item',
    'filter.p.m.wk_custom_field.cus_serial_no': 'serial_no',
    'filter.p.m.wk_custom_field.cus_transferring_dealer': 'transferring_dealer'
  };

  function apiQuery() {
    var page = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();

    Object.keys(FACET_PARAMS).forEach(function (name) {
      page.getAll(name).forEach(function (value) {
        if (value) out.append(FACET_PARAMS[name], value);
      });
    });

    Object.keys(TEXT_PARAMS).forEach(function (name) {
      var value = page.get(name);
      if (value) out.set(TEXT_PARAMS[name], value);
    });

    // "*" was never a real query — it was a stand-in for "everything", which is
    // exactly what this endpoint does without being asked.
    var q = page.get('q');
    if (q && q.trim() && q.trim() !== '*') out.set('q', q.trim());

    // Default: what a buyer can actually buy. The sold archive is 55,163
    // listings against 2,930 live ones, so "everything" buries the live ones.
    var sold = page.get('sold_status');
    out.set('sold_status', sold === 'sold' || sold === 'all' ? sold : 'for_sale');

    ['price_min', 'price_max'].forEach(function (k) {
      var v = page.get(k);
      if (v) out.set(k, v);
    });

    var sort = page.get('sort');
    out.set('sort', sort || 'bumped-desc');

    // Counts come from refreshCounts(), which asks about the BOX. This request
    // is only for the listings, so skip the facet scans entirely -- they were
    // the expensive half of it.
    out.set('facets', '0');
    out.set('page', page.get('page') || '1');
    out.set('limit', /^\/search/.test(window.location.pathname) ? String(CFG.pageSize || 50) : '1');
    return out;
  }

  /* ---------------------------------------------------------------- helpers */

  function esc(value) {
    if (value === null || value === undefined) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function auDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    return pad(d.getDate()) + '-' + pad(d.getMonth() + 1) + '-' + d.getFullYear();
  }

  function money(value) {
    if (value === null || value === undefined) return '';
    return '$' + String(value);
  }

  /* ------------------------------------------------------------------- card */

  var PREMIUM_TYPES = CFG.premiumTypes || [];
  var LABEL = 'color:#900f10;font-weight:bold;';

  function card(p) {
    var type = p.productType || '';
    var lookingFor = type.indexOf('Looking For') !== -1;

    var image =
      p.imageUrl ||
      (lookingFor ? CFG.images.lookingFor : CFG.images.none);

    var html = '';
    html += '<div class="product-card product-grid">';
    html += '<div class="product-grid__inner">';
    html += '<div class="product-card__content" style="border-radius:.25rem !important;border: 1px solid;padding-bottom: 0rem !important;background-color: hsla(0,0%,100%,.5);">';
    html += '<div class="product-card__content--inner  text-center mt-3" style="padding:1rem;">';
    html += '<div style="text-align:left;">';

    /* image */
    html += '<div class="product-card__image-wrapper">';
    html += '<a class="product-card__image-link" href="' + esc(p.url) + '">';
    html += '<img style="max-width:100%;" class="card__image" src="' + esc(image) + '" alt="' + esc(p.title) + '">';
    html += '</a>';
    html += '<div class="product-card__label position-absolute">';
    if (p.sold && CFG.showSoldLabel) {
      html += '<span class="label-sold-out position-relative bg-warning heading-color">';
      html += '<span class="d-block overflow-hidden position-relative">' + esc(CFG.strings.outOfStock) + '</span>';
      html += '</span>';
    }
    html += '</div></div>';

    /* summary */
    html += '<div class="product-card__summary pt-2">';

    if (PREMIUM_TYPES.indexOf(type) !== -1) {
      html += '<div class="premium-listing-badge" style="background: linear-gradient(135deg, #ffd700 0%, #daa520 100%);color:#000;font-weight:bold;padding:3px 10px;border-radius:3px;display:inline-block;margin-bottom:6px;font-size:13px;box-shadow:0 2px 4px rgba(0,0,0,0.15);border:1px solid #c5a028;line-height:1.3;">Premium Listing</div>';
    }

    if (type.indexOf('Arms Fair') !== -1) {
      html += '<span style="color:white;background:linear-gradient(90deg,#c0c0c0,#a9a9a9);font-weight:bold;padding:2px 4px;border-radius:4px;margin-left:8px;display:inline-block;">Hunter Valley Arms Fair</span>';
    }

    if (!p.sold && p.gmarketUrl) {
      html += '<span style="background:#000;color:#fff;font-weight:bold;padding:3px 10px;border-radius:3px;display:inline-block;margin-bottom:6px;font-size:16px;box-shadow:0 2px 4px rgba(0,0,0,0.15);line-height:1.3;">';
      html += '<span style="color:red;">G</span><span style="color:white;">market Listing - Buy It Now</span></span>';
    }

    html += '<div>';
    if (lookingFor) {
      html += '<label style="color:#900f10; font-weight:bold;">Looking For</label>';
    } else if (p.calibre) {
      html += '<label style="' + LABEL + '">Calibre:</label> ' + esc(p.calibre);
    } else {
      html += '<label style="' + LABEL + '">Item:</label> ' + esc(p.item);
    }
    html += '</div>';

    html += '<div><label style="' + LABEL + '">Make:</label> ' + esc(p.make) + '</div>';
    html += '<div><label style="' + LABEL + '">Model:</label> ' + esc(p.model) + '</div>';
    if (p.scope) {
      html += '<div><label style="' + LABEL + '">Scope:</label> ' + esc(p.scope) + '</div>';
    }
    html += '<div><label style="' + LABEL + '">Condition:</label> ' + esc(p.condition) + '</div>';

    if (!lookingFor) {
      html += '<div><label style="' + LABEL + '">Price:</label> ' + esc(money(p.price));
      if (p.priceReduced) {
        html += ' <span style="color:white; background-color:red; font-weight:bold; padding: 2px 4px; border-radius: 4px;">Price Reduced</span>';
      }
      html += '</div>';
    }

    var advertised = auDate(p.bumpedAt);
    html += '<div>';
    if (advertised) {
      html += '<label style="' + LABEL + '">Advertised:</label> ' + esc(advertised);
    }
    html += '</div>';
    html += '</div>';

    /* comment */
    if (p.shortDescription && CFG.showShortDescription) {
      html += '<div class="product-card__summary pt-2"><label style="' + LABEL + '">Comment:</label> ' + esc(p.shortDescription) + '</div>';
      if (!p.calibre) html += '<br>';
    } else {
      html += '<br><br>';
    }

    /* dealer / private badge */
    var t = type.toLowerCase();
    var vendor = (p.vendor || '').toLowerCase();
    var isDealerType =
      t.indexOf('dealer') !== -1 ||
      t.indexOf('safari') !== -1 ||
      t.indexOf('staff') !== -1 ||
      t.indexOf('arms fair special') !== -1;

    html += '<div style="display: flex; justify-content: space-between; align-items: center;"><div>';
    if (isDealerType && vendor !== 'usedguns user 18750') {
      html += '<span style="color:white; background-color:orange; font-weight:bold; padding: 2px 4px; border-radius: 4px;">Dealer Listing</span> ';
      html += esc(p.transferringDealer || p.vendor);
    } else {
      html += '<span style="color:white; background-color:#0074d9; font-weight:bold; padding: 2px 4px; border-radius: 4px;">Private Listing</span> ';
      html += esc(p.state || p.vendor);
    }
    html += '</div></div>';

    /* actions */
    html += '<div class="listing-actions">';
    html += '<label style="color:#900f10; font-weight: bold; margin-right: 0px;">Save This Listing:</label>';
    html += '<div class="th_wl_col_btn" data-product_id="' + esc(p.productId) + '" data-variant_id="' + esc(p.variantId) + '"></div>';
    html += '<a href="' + esc(p.url) + '" class="btn btn--more-details" style="margin-left: 10px; background: linear-gradient(to bottom, #add8e6, #0074d9); color: white; padding: 4px 8px; text-decoration: none; border-radius: 4px; font-weight: bold; border: none; box-shadow: none; font-size: 0.8em;">More Details / Contact Seller</a>';
    html += '</div>';

    // Five opened: product-card, product-grid__inner, product-card__content,
    // content--inner, and the text-align wrapper. Close all five — one short and
    // every card nests inside the last, which silently kills the row gutters.
    html += '</div></div></div></div></div>';
    return html;
  }

  /* -------------------------------------------------------------- rendering */

  function pageUrl(n) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', String(n));
    return u.pathname + u.search;
  }

  function pagination(data) {
    if (data.pages <= 1) return '';
    var current = data.page;
    var html = '<div class="pagination-wrapper d-flex justify-content-center pt-5 mt-xl-4">';
    html += '<nav class="navigation" aria-label="Pagination"><ul class="list-unstyled pagination mb-0">';

    if (current > 1) {
      html += '<li class="page-item"><a href="' + esc(pageUrl(current - 1)) + '" class=" pagination__item pagination__item--next pagination__item-arrow page-link motion-reduce" aria-label="Previous">&lsaquo;</a></li>';
    }

    var from = Math.max(1, current - 3);
    var to = Math.min(data.pages, from + 6);
    for (var n = from; n <= to; n++) {
      html += '<li class="page-item' + (n === current ? ' active' : '') + '"' + (n === current ? ' aria-current="page"' : '') + '>';
      html += '<a href="' + esc(pageUrl(n)) + '" class="pagination__item page-link">' + n + '</a></li>';
    }

    if (current < data.pages) {
      html += '<li class="page-item"><a href="' + esc(pageUrl(current + 1)) + '" class=" pagination__item pagination__item--prev pagination__item-arrow page-link motion-reduce" aria-label="Next">&rsaquo;</a></li>';
    }

    html += '</ul></nav></div>';
    return html;
  }

  // Shopify only renders the results container when its own search found
  // something — precisely the case v2 exists to fix. Build one if absent.
  function isSearchPage() {
    return !!(document.querySelector('#SearchProductGrid') || document.querySelector('.template-search'));
  }

  function resultsContainer() {
    var grid = document.querySelector('#SearchProductGrid');
    if (grid) return grid;

    // Only the search page owns a results grid. Elsewhere the box just filters.
    var host = document.querySelector('.template-search');
    if (!host) return null;

    grid = document.createElement('div');
    grid.id = 'SearchProductGrid';
    grid.className = 'template-search__results';

    var header = document.querySelector('.page-collection-header__left');
    if (header && header.parentNode === host) host.insertBefore(grid, header.nextSibling);
    else host.appendChild(grid);

    // Shopify's "no results" message would otherwise sit above ours.
    document.querySelectorAll('.template-search--empty .title-wrapper, .template-search__empty').forEach(
      function (el) { el.style.display = 'none'; }
    );
    return grid;
  }

  /**
   * Third-party widgets bind to the results on page load. Ours arrive after
   * that, so each one has to be told to look again — otherwise the gallery
   * blocks stay empty and every wishlist button renders blank.
   */
  function reinitEmbeds() {
    var calls = [
      'initXOGallery',            // XO Gallery blocks between listings
      '$th_refreshWishlistItems', // wishlist buttons on each card
      'getTheWishlistItems'
    ];
    calls.forEach(function (name) {
      try {
        if (typeof window[name] === 'function') window[name]();
      } catch (err) {
        if (window.console) console.warn('[search v2] could not re-init ' + name, err);
      }
    });
  }

  function render(data) {
    var grid = resultsContainer();
    if (!grid) return;

    // The theme interleaves a gallery block after every fourth listing, which is
    // part of the page's rhythm as well as its content.
    var cards = data.results
      .map(function (p, i) {
        return card(p) + ((i + 1) % 4 === 0 ? '<div class="xo-gallery" data-id="3"></div>' : '');
      })
      .join('');
    grid.innerHTML =
      '<div class="row g-3 g-md-4">' +
      (cards || '<div class="col-12"><p class="py-5 text-center">No listings match these filters.</p></div>') +
      '</div>' +
      pagination(data);

    grid.removeAttribute('aria-busy');

    var first = data.total === 0 ? 0 : (data.page - 1) * (CFG.pageSize || 50) + 1;
    var last = Math.min(data.page * (CFG.pageSize || 50), data.total);
    document.querySelectorAll('#ProductCount, .collection-product-count').forEach(function (el) {
      el.textContent = 'Showing ' + first + '-' + last + ' of ' + data.total + ' Results';
    });

    reinitEmbeds();

    // Anything else bound to the results can listen for this.
    document.dispatchEvent(new CustomEvent('ug:search-rendered', { detail: data }));
  }

  /* --------------------------------------------------------------- sidebar */

  function orderFor(list) {
    try {
      // Liquid renders "null" when the metaobject field is absent, and
      // JSON.parse("null") is null, not an array — which used to throw.
      var parsed = JSON.parse(list.getAttribute('data-ug-order') || '[]');
      return Array.isArray(parsed) ? parsed.filter(function (v) { return typeof v === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function apiKeyFor(tpl) {
    var probe = tpl ? tpl.content.querySelector('input[name]') : null;
    return probe ? FACET_PARAMS[probe.getAttribute('name')] : null;
  }

  /**
   * Draw one filter group.
   *
   * counts may be null, which is the whole point: the metaobject already tells
   * us which options exist and in what order, so the dropdowns can be filled
   * the moment the page is parsed rather than waiting on a round trip. When the
   * counts arrive they refine the same list in place.
   */
  function renderOptions(list, counts) {
    var tpl = list.querySelector('template.ug-facet-template');
    var apiKey = apiKeyFor(tpl);
    if (!tpl || !apiKey) return;

    // What is ticked in the box right now. Counts refresh while the customer is
    // composing, which rebuilds these <li>s, so the ticks have to survive that --
    // and they come from the DOM, never the URL, because the URL describes the
    // search already on screen rather than the one being built.
    var selected = new Set();
    list.querySelectorAll('input[name]:checked').forEach(function (input) {
      if (input.value) selected.add(input.value);
    });

    var values = counts ? Object.keys(counts) : [];
    orderFor(list).forEach(function (v) { if (values.indexOf(v) === -1) values.push(v); });
    selected.forEach(function (v) { if (values.indexOf(v) === -1) values.push(v); });

    var rank = {};
    orderFor(list).forEach(function (v, i) { rank[v] = i; });
    values.sort(function (a, b) {
      var ra = rank[a] === undefined ? Infinity : rank[a];
      var rb = rank[b] === undefined ? Infinity : rank[b];
      if (ra !== rb) return ra - rb;
      if (!counts) return a.localeCompare(b);
      var d = (counts[b] || 0) - (counts[a] || 0);
      return d !== 0 ? d : a.localeCompare(b);
    });

    var frag = document.createDocumentFragment();
    values.forEach(function (value, i) {
      var n = counts ? counts[value] || 0 : null;
      // Every option stays on the list, including the ones with nothing behind
      // them right now.
      //
      // This used to drop zero-count options, which is the conventional faceted-
      // search behaviour and was wrong for this box: each press of Search is a
      // NEW search, not a refinement of the last one. Pruning made the dropdowns
      // shrink to whatever the previous search happened to contain -- pick
      // Shotguns and the calibre list held only shotgun calibres -- so widening
      // or switching a choice meant resetting the whole box first.
      //
      // The counts are still relative to the other selections, so an option that
      // would return nothing reads "(0)". That is information about this search;
      // the list itself no longer is.

      var li = tpl.content.firstElementChild.cloneNode(true);
      var input = li.querySelector('input');
      var label = li.querySelector('label');
      var id = 'ug-' + apiKey + '-' + i;

      input.value = value;
      input.id = id;
      input.checked = selected.has(value);
      label.setAttribute('for', id);
      li.querySelector('.text').textContent = counts ? value + ' (' + n + ')' : value;
      frag.appendChild(li);
    });

    list.querySelectorAll('li').forEach(function (li) { li.remove(); });
    list.appendChild(frag);
  }

  var TEXT_LABELS = {
    make: 'Make',
    model: 'Model',
    item: 'Item',
    serial_no: 'Serial Number',
    transferring_dealer: 'Transferring Dealer'
  };

  function groupTitleEl(list) {
    var block = list.closest('.block-sidebar');
    return block ? block.querySelector('.filter-top__title') : null;
  }

  function paramNameFor(list) {
    var tpl = list.querySelector('template.ug-facet-template');
    var probe = tpl ? tpl.content.querySelector('input[name]') : null;
    return probe ? probe.getAttribute('name') : null;
  }

  /**
   * The selections shown on each closed dropdown. Liquid renders these from
   * search.filters, which is right on a page load and wrong the moment we
   * filter in place — so we keep them in step ourselves, in the same format.
   */
  function updateGroupTitles() {
    // Reads the FORM, not the URL. The box is a fresh search every time, so what
    // it shows is what you are about to search for -- not what the last search
    // was. The URL still describes the results on screen; renderAppliedFilters()
    // is what reports that.
    var form = document.querySelector('form#CollectionFiltersForm');

    document.querySelectorAll('ul[data-ug-facet-list]').forEach(function (list) {
      var name = paramNameFor(list);
      var title = groupTitleEl(list);
      if (!name || !title) return;

      var slot = title.querySelector('.facets__selected');
      if (!slot) return;

      var values = [];
      if (form) {
        form.querySelectorAll('input[name="' + CSS.escape(name) + '"]:checked').forEach(function (input) {
          if (input.value) values.push(input.value);
        });
      }
      if (!values.length) {
        slot.textContent = '';
        title.classList.remove('has-selections');
        return;
      }

      var shown = values.slice(0, 2).map(function (v) { return '(' + v + ')'; }).join(' ');
      if (values.length > 2) shown += '+(' + (values.length - 2) + ' others)';

      var span = document.createElement('span');
      span.className = 'selected-values-truncated';
      span.textContent = shown;
      slot.textContent = '';
      slot.appendChild(span);
      title.classList.add('has-selections');
    });
  }

  /** The "Applied filters" summary, rebuilt from the URL on every render. */
  function renderAppliedFilters() {
    var host = document.querySelector('#ug-applied-filters');
    if (!host) return;

    var params = new URLSearchParams(window.location.search);
    var rows = [];
    var RED = ' style="color:#FF0000;"';

    var q = (params.get('q') || '').trim();
    if (q && q !== '*') {
      rows.push('<div><span class="bold">Keyword Search: </span><span' + RED + '>' + esc(q) + '</span></div>');
    }

    // Sale status was missing here entirely. It is always in effect and it is
    // the one criterion that silently removes most of the catalogue -- the sold
    // archive dwarfs the live listings -- so leaving it unstated made "For Sale"
    // look like the whole store. Shown whenever the URL carries it, which is
    // after any search from the box; a bare /search still shows nothing.
    var SOLD_LABELS = { for_sale: 'For Sale', sold: 'Sold', all: 'For Sale & Sold' };
    var sold = (params.get('sold_status') || '').trim();
    if (sold && SOLD_LABELS[sold]) {
      rows.push('<div><span class="bold">Show: </span><span' + RED + '>' + esc(SOLD_LABELS[sold]) + '</span></div>');
    }

    document.querySelectorAll('ul[data-ug-facet-list]').forEach(function (list) {
      var name = paramNameFor(list);
      var title = groupTitleEl(list);
      if (!name || !title) return;
      var values = params.getAll(name).filter(Boolean);
      if (!values.length) return;

      var labelEl = title.querySelector('.filter-title-text');
      var label = title.getAttribute('data-filter-name') || (labelEl ? labelEl.textContent : name);

      var parts = values.map(function (v) { return '<span' + RED + '>' + esc(v) + '</span>'; });
      rows.push('<div><span class="bold">' + esc(String(label).trim()) + ': </span>' + parts.join('<span' + RED + '>,</span> ') + '</div>');
    });

    Object.keys(TEXT_LABELS).forEach(function (key) {
      var value = (params.get(key) || '').trim();
      if (!value) return;
      rows.push('<div><span class="bold">' + esc(TEXT_LABELS[key]) + ': </span><span' + RED + '>' + esc(value) + '</span></div>');
    });

    var lo = (params.get('price_min') || '').trim();
    var hi = (params.get('price_max') || '').trim();
    if (lo || hi) {
      var money = (lo ? '$' + esc(lo) : 'Any') + ' to ' + (hi ? '$' + esc(hi) : 'Any');
      rows.push('<div><span class="bold">Price: </span><span' + RED + '>' + money + '</span></div>');
    }

    host.innerHTML = rows.length ? '<span class="h4">Applied filters</span>' + rows.join('') : '';
  }

  function populateFacets(facets) {
    // The mobile overlay copies the real checkboxes into its own list and keeps
    // references to them until Apply. Rebuilding the <li>s underneath it would
    // detach exactly those nodes, so Apply would tick checkboxes that are no
    // longer in the document and the selection would vanish silently. Skip the
    // redraw while it is open; Apply fires a change, and the counts refresh
    // immediately after.
    var overlay = document.getElementById('mobile-filter-overlay');
    if (overlay && overlay.classList.contains('active')) return;

    document.querySelectorAll('ul[data-ug-facet-list]').forEach(function (list) {
      try {
        var tpl = list.querySelector('template.ug-facet-template');
        var apiKey = apiKeyFor(tpl);
        renderOptions(list, facets && apiKey ? facets[apiKey] || {} : null);
      } catch (err) {
        // One malformed group should not leave every other dropdown empty.
        if (window.console) console.error('[search v2] facet group failed', err);
      }
    });

    updateGroupTitles();
    renderAppliedFilters();
    syncResetButton();
  }

  /* --------------------------------------------------------- interaction */

  var FILTER_KEYS = Object.keys(FACET_PARAMS)
    .concat(Object.keys(TEXT_PARAMS))
    .concat(['q', 'sold_status', 'price_min', 'price_max', 'sort', 'page']);

  function urlFromForm() {
    var url = new URL(window.location.href);
    FILTER_KEYS.forEach(function (k) { url.searchParams.delete(k); });

    var form = document.querySelector('form#CollectionFiltersForm');
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (FILTER_KEYS.indexOf(key) === -1) return;
        var v = value === null ? '' : String(value).trim();
        if (v === '') return;
        if (key === 'q' && v === '*') return; // never round-trip the old wildcard
        url.searchParams.append(key, v);
      });
    }

    url.searchParams.delete('page'); // any filter change returns to page one
    return url;
  }

  function go(url, push) {
    if (push !== false) {
      window.history.pushState({}, '', url.pathname + url.search);
    }
    load();
    var grid = document.querySelector('#SearchProductGrid');
    if (grid && grid.getBoundingClientRect().top < 0) {
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // On back/forward the form has to be put back the way the URL describes.
  /**
   * "Clear Active Filters" is enabled whenever there is something to clear --
   * which now means the CURRENT SEARCH as well as anything typed into the box.
   *
   * The snippet used to decide this from the box alone. That broke the moment
   * searches started clearing the box: the button went disabled exactly when the
   * customer had a search on screen to clear. Its click handler navigates to the
   * bare path, so enabling it is all that was missing.
   */
  function syncResetButton() {
    var btn = document.getElementById('js-filter-reset');
    if (!btn) return;

    var ignored = ['sort', 'page'];
    var params = new URLSearchParams(window.location.search);
    var active = false;

    params.forEach(function (value, key) {
      if (active || !value) return;
      if (FILTER_KEYS.indexOf(key) === -1) return;
      if (ignored.indexOf(key) !== -1) return;
      // for_sale is the default view, so a URL carrying only that is not a
      // search anyone needs to clear.
      if (key === 'sold_status' && value === 'for_sale') return;
      active = true;
    });

    var form = document.querySelector('form#CollectionFiltersForm');
    if (!active && form) {
      new FormData(form).forEach(function (value, key) {
        if (active) return;
        if (FILTER_KEYS.indexOf(key) === -1 || ignored.indexOf(key) !== -1) return;
        var v = value === null ? '' : String(value).trim();
        if (!v || (key === 'sold_status' && v === 'for_sale')) return;
        active = true;
      });
    }

    btn.disabled = !active;
  }

  /**
   * Empty the box back to its defaults.
   *
   * This replaced syncFormFromUrl(), which mirrored the URL back into the form.
   * That made the box a filter: whatever the last search had selected stayed
   * ticked, so the next choice was added to it and the results could only ever
   * get narrower. Every press of Search is now a new search, so the box is empty
   * on arrival, after each search, and on back/forward.
   *
   * The criteria behind the results on screen are not lost -- the URL still
   * carries them and renderAppliedFilters() shows them, with a chip per value if
   * the customer wants to drop one.
   */
  function resetFormToDefaults() {
    var form = document.querySelector('form#CollectionFiltersForm');
    if (!form) return;

    ['price_min', 'price_max'].concat(Object.keys(TEXT_PARAMS)).concat(['q']).forEach(function (name) {
      var field = form.querySelector('[name="' + CSS.escape(name) + '"]');
      if (field) field.value = '';
    });

    var sold = form.querySelector('[name="sold_status"]');
    if (sold) sold.value = 'for_sale';

    Object.keys(FACET_PARAMS).forEach(function (name) {
      form.querySelectorAll('input[name="' + CSS.escape(name) + '"]').forEach(function (input) {
        input.checked = false;
      });
    });

    updateGroupTitles();
    syncResetButton();
    // Emptying the box is itself a change of search: the numbers go back to
    // describing the whole catalogue. Covers arrival, post-search and popstate.
    scheduleCounts();
  }

  /**
   * Off the search page, go straight to /search.
   *
   * The theme's <facet-filters-form> element also listens for this submit and
   * runs its own AJAX filter against the current collection. That produced the
   * double behaviour: results shifting in place, then a full navigation. Taking
   * the event in the capture phase stops it reaching that handler at all.
   */
  function bindCrossPageSubmit() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.id !== 'CollectionFiltersForm') return;

        e.preventDefault();
        e.stopPropagation();

        if (isSearchPage()) {
          // Read the box, run the search, then empty it. Text inputs are not
          // rebuilt by renderOptions() the way the checkboxes are, so they have
          // to be cleared explicitly.
          go(urlFromForm());
          resetFormToDefaults();
          return;
        }

        var url = new URL('/search', window.location.origin);
        new FormData(form).forEach(function (value, key) {
          if (FILTER_KEYS.indexOf(key) === -1) return;
          var v = value === null ? '' : String(value).trim();
          if (v === '') return;
          if (key === 'q' && v === '*') return;
          url.searchParams.append(key, v);
        });
        url.searchParams.set('type', 'product');

        window.location.href = url.pathname + url.search;
      },
      true
    );
  }

  var debounceTimer;
  function bind() {
    var form = document.querySelector('form#CollectionFiltersForm');
    if (!form) return;

    // Labels only -- this runs no search. Without it the dropdown buttons would
    // sit blank while the customer ticks boxes, because the titles now describe
    // the form rather than the URL and nothing else redraws them until Search.
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name && FILTER_KEYS.indexOf(e.target.name) !== -1) {
        updateGroupTitles();
        syncResetButton();
        scheduleCounts();
      }
    });

    // Deliberately no 'change' or 'input' handler that SEARCHES. Filters are
    // composed and then applied with the Search button, which is what the theme's
    // own UI implies
    // and what stops a five-checkbox selection firing five searches.

    document.addEventListener('click', function (e) {
      // bind() runs anywhere the filter box exists, which now includes collection
      // pages and the home page -- but v2 only owns the results on a search page.
      // Without this guard the handler below cancelled every pagination click on
      // a collection page and then painted into a #SearchProductGrid that isn't
      // there, so page 2 simply never arrived. Collection pages keep the theme's
      // own pagination links and facet removals; only the form-submit handler,
      // which is bound separately, still applies there.
      if (!isSearchPage()) return;

      var pageLink = e.target.closest('.pagination a');
      if (pageLink) {
        e.preventDefault();
        var target = new URL(pageLink.href, window.location.origin);
        go(target);
        return;
      }

      var remove = e.target.closest('a.js-facet-remove');
      if (remove) {
        e.preventDefault();
        var url = new URL(window.location.href);
        if (remove.classList.contains('active-facets__clear_all')) {
          FILTER_KEYS.forEach(function (k) { url.searchParams.delete(k); });
        } else {
          var name = remove.getAttribute('data-ug-param');
          var value = remove.getAttribute('data-ug-value');
          if (name) {
            var kept = url.searchParams.getAll(name).filter(function (v) { return v !== value; });
            url.searchParams.delete(name);
            kept.forEach(function (v) { url.searchParams.append(name, v); });
          }
        }
        url.searchParams.delete('page');
        go(url);
      }
    });

    window.addEventListener('popstate', function () {
      resetFormToDefaults();
      load(false);
    });
  }

  // Chips for what is currently applied, replacing the Liquid-rendered ones.
  function renderChips() {
    var host = document.querySelector('.active-facets');
    if (!host) return;
    var params = new URLSearchParams(window.location.search);
    var html = '';

    Object.keys(FACET_PARAMS).forEach(function (name) {
      params.getAll(name).forEach(function (value) {
        html += '<a class="active-facets__button active-facets__button--light js-facet-remove" href="#" ' +
          'data-ug-param="' + esc(name) + '" data-ug-value="' + esc(value) + '">' + esc(value) + ' &times;</a>';
      });
    });

    Object.keys(TEXT_PARAMS).forEach(function (name) {
      var value = params.get(name);
      if (value) {
        html += '<a class="active-facets__button active-facets__button--light js-facet-remove" href="#" ' +
          'data-ug-param="' + esc(name) + '" data-ug-value="' + esc(value) + '">' + esc(value) + ' &times;</a>';
      }
    });

    if (html) {
      html += '<a href="#" class="active-facets__button active-facets__clear_all js-facet-remove p-0">Clear All</a>';
    }
    host.innerHTML = html;
  }

  /* ------------------------------------------------------------------ boot */

  /* ------------------------------------------------------- option counts */

  /**
   * The numbers beside each option describe the search being COMPOSED, not the
   * one on screen.
   *
   * Before this, counts came back with the results and so described the URL --
   * which, now that every search starts from an empty box, was actively
   * misleading: it showed the last search narrowing a new one that will not
   * inherit it. Reading the box instead means ticking Rimfire immediately shows
   * Condition "Fair (3)" rather than "Fair (20)", while the listings on screen
   * stay exactly where they were until Search is pressed.
   *
   * The API already computes each group's counts with every filter EXCEPT that
   * group's own, so ticking one calibre does not zero the other calibres.
   */
  function countsQuery() {
    var out = new URLSearchParams();
    var form = document.querySelector('form#CollectionFiltersForm');

    if (form) {
      new FormData(form).forEach(function (value, key) {
        var v = value === null ? '' : String(value).trim();
        if (!v) return;
        if (FACET_PARAMS[key]) return out.append(FACET_PARAMS[key], v);
        if (TEXT_PARAMS[key]) return out.set(TEXT_PARAMS[key], v);
        if (key === 'q') { if (v !== '*') out.set('q', v); return; }
        if (key === 'sold_status' || key === 'price_min' || key === 'price_max') out.set(key, v);
      });
    }

    if (!out.has('sold_status')) out.set('sold_status', 'for_sale');
    out.set('limit', '1'); // counts only -- the listings are somebody else's job
    out.set('facets', '1');
    return out;
  }

  var countsSeq = 0;
  var countsTimer;

  function refreshCounts() {
    var seq = ++countsSeq;
    return fetch(CFG.apiBase.replace(/\/+$/, '') + '/api/search?' + countsQuery().toString(), {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('counts API returned HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        // A slower earlier request must not overwrite a newer one's numbers.
        if (seq === countsSeq) populateFacets(data.facets || {});
      })
      .catch(function (err) {
        // Counts are decoration; stale numbers beat a broken box.
        if (window.console) console.error('[search v2] counts', err);
      });
  }

  function scheduleCounts() {
    clearTimeout(countsTimer);
    countsTimer = setTimeout(refreshCounts, 250);
  }

  function request() {
    return fetch(CFG.apiBase.replace(/\/+$/, '') + '/api/search?' + apiQuery().toString(), {
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('search API returned HTTP ' + res.status);
      return res.json();
    });
  }

  // Fired immediately on script execution, before the DOM exists, so the round
  // trip overlaps with parsing the rest of the page instead of following it.
  // Only /search needs data before the DOM exists. Elsewhere (product pages
  // share this layout) we wait and check whether a filter box is even present,
  // rather than firing a request on every page view.
  var onSearchPath = /^\/search/.test(window.location.pathname);
  var pending = onSearchPath ? request() : null;
  if (pending) pending.catch(function () {}); // load() attaches the real handler

  var earlyRendered = false;

  /**
   * The results container appears partway through parsing, long before
   * DOMContentLoaded. Watching for it lets the listings paint as soon as both
   * the markup and the data exist, instead of waiting for the rest of the page
   * — scripts, images, embedded apps — to finish.
   */
  (function watchForGrid() {
    if (!/^\/search/.test(window.location.pathname)) return;
    if (typeof MutationObserver !== 'function') return;

    var observer;
    var paint = function () {
      var grid = document.querySelector('#SearchProductGrid');
      if (!grid || earlyRendered) return;
      earlyRendered = true;
      if (observer) observer.disconnect();
      pending
        .then(function (data) {
          render(data);
        })
        .catch(function () {
          earlyRendered = false; // let the normal path show the error state
        });
    };

    observer = new MutationObserver(paint);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () {
      if (observer) observer.disconnect();
    });
    paint();
  })();

  function load(push) {
    var searchPage = isSearchPage();
    var grid = searchPage ? resultsContainer() : null;
    if (grid) grid.setAttribute('aria-busy', 'true');

    var inflight = pending || request();
    pending = null; // subsequent searches fetch fresh

    return inflight
      .then(function (data) {
        if (searchPage && !earlyRendered) render(data);
        earlyRendered = false; // only the first paint is pre-empted
        renderAppliedFilters();
        syncResetButton();
        if (searchPage) renderChips();
        if (grid) grid.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        if (window.console) console.error('[search v2]', err);
        if (!grid || !searchPage) return;
        grid.removeAttribute('aria-busy');
        grid.innerHTML =
          '<div class="ug-error">' +
          '<p><strong>Listings could not be loaded just now.</strong></p>' +
          '<p>This is a temporary problem at our end, not a problem with your search.</p>' +
          '<p><a href="#" class="btn btn--more-details ug-retry">Try again</a></p>' +
          '</div>';
        var retry = grid.querySelector('.ug-retry');
        if (retry) {
          retry.addEventListener('click', function (e) {
            e.preventDefault();
            load(false);
          });
        }
      });
  }

  function start() {
    var hasBox = document.querySelectorAll('ul[data-ug-facet-list]').length > 0;
    if (!hasBox && !isSearchPage()) return; // nothing here to drive

    bindCrossPageSubmit();

    // Draw the dropdowns immediately from the metaobject order already in the
    // HTML — no network, so the options are there as soon as the page is.
    populateFacets(null);
    resetFormToDefaults();
    bind();
    // Counts follow, refining the same lists and pruning empty options.
    load(false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
